import { type ReactNode } from 'react';

import styles from './Scrollable.module.scss';

function Scrollable({ children }: { children: ReactNode }) {
  return (
    <div className={styles.scrollWrapper}>
      <div className={styles.scrollable}>{children}</div>
    </div>
  );
}

export default Scrollable;
